/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BloodResultCodingDto } from './BloodResultCodingDto';
import type { ReferenceRangeDto } from './ReferenceRangeDto';

export type BloodResultDto = {
    patientId?: string;
    serviceRequestId: string;
    providerPatientId?: string;
    labName?: string;
    observationId: string;
    coding: BloodResultCodingDto;
    value: string;
    unit?: string;
    referenceRange: ReferenceRangeDto;
    dateIssued: string;
    status: BloodResultDto.status;
    note?: string;
};

export namespace BloodResultDto {

    export enum status {
        FINAL = 'final',
    }


}

